import axios from "axios";
import { useEffect, useState } from "react";
import CampaignStatsTopDevicesItem from "./CampaignStatsTopDevicesItem";

function CampaignStatsTopDevices({ campaign_id }) {
    const [devices, setDevices] = useState([]);

    function getTopDevices() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/campaign/stats/devices/?campaign_id=${campaign_id}`,
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setDevices(response.data);
            }
        )
    }

    const divDevices = devices.map(
        d =>
            <CampaignStatsTopDevicesItem
                device_id={d.device_id}
                impressions_count={d.dcount}
            />
    )

    useEffect(
        () => {
            getTopDevices();
        },
        [],
    )

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                    Top Devices
                </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {divDevices}
            </div>
        </div>
    );
}

export default CampaignStatsTopDevices;